export enum AwardType {
  canstar202122 = 'canstar202122',
  financialAwards2021 = 'financialAwards2021',
}

export interface DisclaimerContent {
  disclaimer: JSX.Element;
  disclaimerSymbol: string;
}

export interface Award {
  logo: string;
  content: string;
  flowsToDisplay: Array<string>;
  stepsToIgnore: Array<string>;
  disclaimerSymbol?: string;
  disclaimer?: JSX.Element;
}

export interface AwardData {
  [key: string]: Award;
}
